
<template>
  <div class="app-vue">
    <router-view v-if="isRouterAlive" />
  </div>
</template>



<script>
export default {
  name: "App",
  components: {},
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {
    if (this._isMobile()) {
      // $("body").css("zoom", ".3");
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style lang="less">
@import "./less/grid";
@import "./less/form";
@import "./less/button";
@import "./less/query";
@import "./less/table";
@import "./less/cli";
@import "./less/reset.less";
@import "./less/common.less";

.app-vue{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue